import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showSessionAIMsgSelector = createSelector(testTargetOffersSelector, offers => offers.showSessionAIMsg || Empty.Object);

export { showSessionAIMsgSelector };
